<script setup>
import { reactiveOmit } from "@vueuse/core";
import { TabsList } from "reka-ui";
import { cn } from "@/lib/utils";

const props = defineProps({
  loop: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <TabsList
    v-bind="{ ...delegatedProps, ...$attrs }"
    :class="
      cn(
        'vf-inline-flex vf-items-center vf-text-muted-foreground',
        'vf-w-full vf-border-b vf-border-neutral-300',
        props.class
      )
    "
  >
    <slot />
  </TabsList>
</template>
